import { withTranslation } from "react-i18next"
import { useState, useEffect } from "react"
import { Spin } from "antd"

// Utils
import { get } from "library/endpoints"
import PictureSelection from "../../components/PictureSelection";
import Recipient from "../../components/Recipient";
import Basket from "../../components/Basket";

import * as Styled from '../../components/styled';
import Footer from "screens/Giftcard/components/Footer";


/**
 * Giftcard
 * @param {*} props 
 * @returns 
 */
const Giftcard = (props) => {
  const [categories, setCategories] = useState([])
  const [pictures, setPictures] = useState([])
  const [selectedPicture, setSelectedPicture] = useState(null)
  const [currentView, setCurrentView] = useState('picture-selection')

  const [userSelection, setUserSelection] = useState({
    picture: null,
    category: null,
    amount: null,
    userFromName: null,
    userToName: null,
    message: null,
    email: null,
    to_email: null,
    type: 'by_email',
  })

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
      const response = await get(`frontend/giftcards`);
      const defaultPicture = response.data.pictures.find((pic) => pic.is_default);

      setCategories(response.data.categories)
      setPictures(response.data.pictures)
      setSelectedPicture(defaultPicture)
      setUserSelection({
        ...userSelection,
        picture: defaultPicture
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnSelectCategory = (category) => {
    setUserSelection({
      ...userSelection,
      category
    })
    setCurrentView('recipient')
  }

  const handleOnSubmitAmount = (amount) => {
    setUserSelection({
      ...userSelection, 
      category: null,
      amount
    })
    setCurrentView('recipient')
  }

  const renderView = () => {
    switch (currentView) {
      case 'recipient':
        return (
          <Recipient 
            userSelection={userSelection}
            setUserSelection={setUserSelection}
            setCurrentView={setCurrentView}
          />
        );
      case 'basket':
        return (
          <Basket
            userSelection={userSelection}
            setUserSelection={setUserSelection}
            setCurrentView={setCurrentView}
          />
        )
      default:
        return (
          <PictureSelection
            categories={categories}
            pictures={pictures}
            selectedPicture={selectedPicture}
            setSelectedPicture={setSelectedPicture}
            handleOnSubmitAmount={handleOnSubmitAmount}
            handleOnSelectCategory={handleOnSelectCategory}
          />
        )
    }
  }

  if (pictures.length === 0 || !selectedPicture) {
    return <Spin />;
  }

  return (
    <div>
      <Styled.StyledWrapper>
        <img alt="giftcard" src={`${process.env.REACT_APP_S3_FILES_URL}${selectedPicture.file}`} style={{ width: '100%', borderRadius: '3px 3px 0 0', borderBottom: '2px solid #e5e7eb' }} />

        {renderView()}

        <Footer />
        
      </Styled.StyledWrapper>
    </div>
  )
}

export default withTranslation()(Giftcard)